<div class="helper-text-edit-container">
    <div class="helper-text-header">
        <button (click)="openAddHelpTextDialog()"
          class="btn-outline bg-primary-300 text-primary btn-icon btn rounded-round mr-4"
          tabindex="0">
          <i class="icon-plus-circle2 mr-"></i> ADD NEW HELPER TEXT
        </button>
    </div>

    <div class="helper-text-body hub-custom-scrollbar">
        @if (helperTextForms) {
        <div [formArray]="helperTextForms">
            <table style="position: relative;">
                <thead>
                    <td style="width: 40px">Help Text ID</td>
                    <td style="width: 160px">Context</td>
                    <td style="width: 120px">Label</td>
                    <td style="width: 280px">Content (HTML)</td>
                    <td style="width: 120px;">Read More URL</td>
                </thead>
                <tbody>
                    @for (helperTextForm of helperTextForms.controls; track helperTextForm) {
                    <tr [id]="'helpText_' + helperTextForm.controls.helpTextId.value">
                        <td class="helper-text-id">
                            {{helperTextForm.controls.helpTextId.value}}
                        </td>
                        <td [ngClass]="{'invalid': helperTextForm.controls.context.invalid}">
                            <input [formControl]="helperTextForm.controls.context" maxlength="255">
                        </td>
                        <td [ngClass]="{'invalid': helperTextForm.controls.label.invalid}">
                            <input [formControl]="helperTextForm.controls.label" maxlength="255">
                        </td>
                        <td [ngClass]="{'invalid': helperTextForm.controls.contentHtmlShort.invalid}">
                            <div class="text-entry-column">
                                <textarea rows="3" [formControl]="helperTextForm.controls.contentHtmlShort" maxlength="1000"></textarea>
                                <div class="chars-remaining" [ngClass]="{'out-of-space':(1000 - helperTextForm.controls.contentHtmlShort.value.length) <= 0}">
                                    {{1000 - helperTextForm.controls.contentHtmlShort.value.length}}
                                    character{{1000 - helperTextForm.controls.contentHtmlShort.value.length !== 1 ? 's' : ''}} remaining
                                </div>
                            </div>
                        </td>
                        <td [ngClass]="{'invalid': helperTextForm.controls.link.invalid}">
                            <div class="text-entry-column">
                                <textarea rows="3" [formControl]="helperTextForm.controls.link" maxlength="2000"></textarea>
                                <div class="chars-remaining"></div>
                            </div>
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
        }


    </div>

    <div class="helper-text-footer">
        <button class="hub-outline-button" [disabled]="helperTextForms?.pristine" (click)="resetRequested()">Cancel</button>

        <button type="button" class="hub-icon-button SaveButton" [ngClass]="{ saving: isSaving }"
            [disabled]="isSaveButtonDisabled || isSaving" (click)="saveAll()">
            <b>
                <i class="icon-floppy-disk"></i>
                <i class="icon-spinner4"></i>
            </b>
            Save
        </button>
    </div>

</div>
